export default {
  routes: [
    {
      name: 'scores',
      path: '/directory/score',
      component: () => import('./views/TheScores.vue'),

    },

    {
      name: 'score',
      path: '/directory/score/:uuid',
      component: () => import('./views/TheScore.vue'),
    },
  ]
}
